export function ArtifactsPage() {
  return (
    <div className="p-8">
      <h1 className="font-display text-2xl font-bold text-text-primary mb-2">Artifacts</h1>
      <p className="text-text-secondary">Coming soon — generated business documents and assets.</p>
    </div>
  )
}
